import template from './app.html';
import controller from './app.controller';
import './app.scss';

controller.$inject = ['$http', '$scope', '$rootScope', '$timeout'];

const appComponent = {
  template,
  controller
};

export default appComponent;
